export default __webpack_public_path__ + "static/media/waves.eba5ec16.svg";